import z from 'zod';
import { uploadCreateResponse } from './upload.responses';

export const attachmentUploadUrlResponse = z.array(uploadCreateResponse);

export type AttachmentUploadUrlResponse = z.infer<typeof attachmentUploadUrlResponse>;
